// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"121":"QADetail","190":"VideoList","875":"InvoiceList","913":"default"}[chunkId] + "." + {"121":"21d8dcfb","190":"59b3f7ba","875":"f88aa3f6","913":"28a6a49a"}[chunkId] + ".css";
};